module.exports = __webpack_public_path__ + "b0b6726349111dfdfbaab432d5e7a929.svg";